import { FilterParams } from "src/library/utils";
import useAxios from "src/core/shared/hooks/useAxios";
import type { InstalledModuleType } from "src/utils/constants";
import {
  EndpointConfig,
  RequestConfig,
  UseApiRequest
} from "src/core/shared/api/config.api";

export type GetMeticDataParams = { filters: FilterParams<Pick<IMetricData, "createdAt" | "metricId">> };

const BASE_URL = `${process.env.REACT_APP_API_URL}/core/analytics/metrics`;

type AnalyticsEndpointConfig = {
  GET_METRIC_DATA: EndpointConfig<
    GetMeticDataParams,
    IMetricData[]
  >;
  LIST_METRICS: EndpointConfig<
    null,
    IMetric[]
  >;
};

const requests: RequestConfig<AnalyticsEndpointConfig> = {
  GET_METRIC_DATA: (params, cache) => ({
    ...cache,
    url: `${BASE_URL}/data`,
    method: "GET",
    params
  }),
  LIST_METRICS: (params, cache) => ({
    ...cache,
    url: `${BASE_URL}`,
    method: "GET",
    params
  })
};

export const useAnalyticsApi: UseApiRequest<AnalyticsEndpointConfig> = name => useAxios(requests[ name ], name);

export interface IMetricData {
  id: number;
  metricId: number;
  value: number;
  scope: IMetric["scope"];
  entityId: number | null; // customer/branch ids
  createdAt: string;
}

export interface IMetric {
  id: number;
  type: MetricType;
  scope: "global" | "customer" | "branch";
  module?: InstalledModuleType;
  name: string;
  frequency: MetricFrequency;
  cumulative: boolean;
  data?: IMetricData[];
}

export type MetricFrequency = "daily" | "monthly";
export type MetricType =
  | "admin-users"
  | "customer-users"
  | "total-orders-count"
  | "total-orders-value"
  | "bulk-total-orders-value"
  | "bulk-total-orders-count"
  | "branches"
  | "bulk-branches";
